export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:beforeMount', async () => {
    const isClientInjection = !!window.__NAVIGATION__ENV_PROPS__;

    if (!isClientInjection) {
      return;
    }

    if (document.getElementById('teleports')) {
      return;
    }

    const ensureTeleportRoot = () => {
      const teleports = document.createElement('div');
      teleports.id = 'teleports';

      const navFooter = document.getElementById('nav-footer');

      if (navFooter) {
        navFooter.replaceWith(teleports);
      } else {
        document.body.append(teleports);
      }
    };

    if (document.readyState !== 'loading' && document.body) {
      ensureTeleportRoot();
      return;
    }

    await new Promise((resolve) => {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          ensureTeleportRoot();
          resolve();
        },
        { once: true },
      );
    });
  });
});
